<div class="documents-page">
    <div class="container">
        <div class="info-content">
            <div class="info">
                <div class="portalLogo"></div>
                <self-ins-policies-and-request-page></self-ins-policies-and-request-page>
            </div>
            <div class="contacts">
                <p class="m-0">Contact us:</p>
                <div>
                    <a href="mailto:AFPsupport@mcgriff.com?subject={{user?.verificationInfo?.insuredName ? user?.verificationInfo?.insuredName : ''}}">
                        AFPsupport@mcgriff.com
                    </a>
                    <span></span>
                    <a href="tel:+18448186243">844-818-6243</a>
                </div>
            </div>
            <div class="footer mt-2">
                <a
                    href="https://www.marshmma.com/us/privacy-notice.html"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy Notice
                </a>
            </div>
        </div>
        <div class="main-content">
            <div class="row">
                <div class="col-3">
                    <label>
                        <input type="checkbox" id="policyDocs" name="policyDocs" [(ngModel)]="policyDocs"
                        (change)="toggleDocTypes('FILEREG', policyDocs)">
                        Policy Documents
                    </label>
                </div>
                <div class="col-3">
                    <label>
                        <input type="checkbox" id="insuredDocs" name="insuredDocs" [(ngModel)]="insuredDocs"
                        (change)="toggleDocTypes('INSURED', insuredDocs)">
                        Insured Documents
                    </label>
                </div>
            </div>
            <div class="table-cont mt-2">
                <div class="table-block">
                    <table mat-table matSort class="bordered" [dataSource]="documents">
                        <ng-container matColumnDef="type">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>Type</th>
                            <td mat-cell *matCellDef="let file">
                                <ng-container>
                                    <div [ngSwitch]="file.iconClass">
                                        <img *ngSwitchCase="'jetfileicon jetfileicon-email'"
                                            src="../../../assets/img/icon_email-white.png" alt="email">
                                        <img *ngSwitchCase="'jetfileicon jetfileicon-office-word' || 'jetfileicon jetfileicon-office-powerpoint'"
                                            src="../../../assets/img/icon_doc_white.png" alt="doc">
                                        <img *ngSwitchCase="'jetfileicon jetfileicon-office-excel'"
                                            src="../../../assets/img/icon_xlsx_white.png" alt="doc">
                                        <img *ngSwitchCase="'jetfileicon jetfileicon-pdf'"
                                            src="../../../assets/img/icon_pdf_white.png" alt="pdf">
                                        <img *ngSwitchCase="'jetfileicon jetfileicon-image-document'"
                                            src="../../../assets/img/icon_img_white.png" alt="pdf">
                                        <img *ngSwitchCase="'jetfileicon jetfileicon-text-document'"
                                            src="../../../assets/img/icon_txt_white.png" alt="txt">
                                    </div>
                                </ng-container>
                                <div [ngSwitch]="file.iconClass">
                                    <p *ngSwitchCase="'jetfileicon jetfileicon-new disabled'">file</p>
                                    <p *ngSwitchCase="'jetfileicon jetfileicon-note'">note</p>
                                    <p *ngSwitchCase="'jetfileicon jetfileicon-video'">video</p>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="dateCreated">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>Date created</th>
                            <td mat-cell *matCellDef="let file">
                                {{file.dateCreated | date:'shortDate'}}</td>
                        </ng-container>
                        <ng-container matColumnDef="fileName">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>File name</th>
                            <td mat-cell *matCellDef="let file">
                                <a
                                    (click)="download(file.fileLocation, file.iconClass, file.documentId)">{{file.description}}</a>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="source">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>Source</th>
                            <td mat-cell *matCellDef="let file">
                                {{ file.source }}</td>
                        </ng-container>
                        <ng-container matColumnDef="links">
                            <th mat-header-cell *matHeaderCellDef>Action</th>
                            <td mat-cell *matCellDef="let file">
                                <div class="links">
                                    <a *ngIf="!(file.iconClass === 'jetfileicon jetfileicon-email' ||
                                                            file.iconClass === 'jetfileicon jetfileicon-note' ||
                                                            file.iconClass === 'jetfileicon jetfileicon-new disabled')"
                                        (click)="download(file.fileLocation, file.iconClass, file.documentId)">
                                        <ng-container>
                                            <img src="../../../assets/img/btn-download-white.png" alt="download">
                                        </ng-container>
                                    </a>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="docCols"></tr>
                        <tr mat-row class="table-row" *matRowDef="let row; columns: docCols;"></tr>
                    </table>
                </div>
                <div class="table-actions mt-2">
                    <p class="m-0">
                        <a href="mailto:AFPsupport@mcgriff.com?subject={{user?.verificationInfo?.insuredName ? user?.verificationInfo?.insuredName : ''}}">
                            Report
                        </a>
                        incorrect information
                    </p>
                </div>
            </div>
            <div class="actions pt-3">
                <button class="primary-button"
                        [routerLink]="user?.status === 'active' ? ['/coverage'] : ['/verification']"
                        [queryParams]="user?.status === 'active' ? { qnum: qnum, qsuffix: qsuffix } : null">
                    Go back
                </button>
            </div>
        </div>
    </div>
</div>
